// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3f5Mu","errorLogs":"styles_errorLogs__2wIxl"};